import React, { useState, useEffect } from "react";
import "../CSS/kyc.css";
import digilockerLogo from "../images/digilocker-logo.jpeg";
import axios from "axios";
import Swal from "sweetalert2"; //  SweetAlert
import {
  FaUser,
  FaIdCard,
  FaClipboardCheck,
  FaCheck,
  FaArrowRight,
  FaArrowLeft,
  FaSyncAlt,
  FaShieldAlt,
  FaTachometerAlt,
} from "react-icons/fa";
import Sidebar from "./Sidebar";
import { BASE_API_URL } from "../constants";


// const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

const KYCPage = () => {
  const [step, setStep] = useState(1);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [kycResponse, setKycResponse] = useState(null);
  const [extractedData, setExtractedData] = useState(null);
  const [freshlyVerified, setFreshlyVerified] = useState(false);
  const [formData, setFormData] = useState({
    customer_identifier: "",
    customer_name: "",
    email: "",
    dob: "",
  });

  // --- Check if user already has approved KYC
  // useEffect(() => {
  //   const initialCheck = async () => {
  //     if (!formData.customer_identifier) {
  //       setIsInitialLoading(false);
  //       return;
  //     }
  //     try {
  //       const res = await axios.get(
  //         `${API_BASE}/api/get-kyc-status-by-user?customer_identifier=${formData.customer_identifier}`
  //       );
  //       const data = res.data;

  //       if (data.status === "approved") {
  //         setVerificationComplete(true);
  //         setStep(3);
  //         setExtractedData(data.extracted_data || null);
  //         Swal.fire({
  //           icon: "success",
  //           title: "KYC Verified ",
  //           text: "Your KYC is already completed!",
  //         });
  //       } else if (data.status === "pending") {
  //         setStep(2);
  //         setMessage({ type: "info", text: "KYC is in progress." });
  //       }
  //     } catch (err) {
  //       console.error("Initial KYC check failed:", err);
  //     } finally {
  //       setIsInitialLoading(false);
  //     }
  //   };

  //   initialCheck();
  // }, [formData.customer_identifier]);
  useEffect(() => {
    const loadLoggedInUserAndCheckKyc = async () => {
      const sessionName =
        sessionStorage.getItem("userName") ||
        sessionStorage.getItem("username") ||
        "";
      const sessionEmail = sessionStorage.getItem("email") || "";
      let mobile =
        sessionStorage.getItem("mobile") ||
        sessionStorage.getItem("phone") ||
        "";
      let customerName = sessionName;

      setFormData((prev) => ({
        ...prev,
        customer_name: customerName,
        customer_identifier: mobile,
        email: sessionEmail,
      }));

      try {
        if (sessionEmail) {
          const profileRes = await axios.get(
            `${BASE_API_URL}/api/user-profile?email=${encodeURIComponent(sessionEmail)}`
          );
          const user = profileRes.data?.user || {};

          customerName = user.username || customerName;
          mobile = user.phone || user.mobilenumber || mobile;

          setFormData((prev) => ({
            ...prev,
            customer_name: customerName,
            customer_identifier: mobile,
            email: user.email || sessionEmail,
          }));
        }

        if (!mobile) {
          return;
        }

        const res = await axios.get(
          `${BASE_API_URL}/api/get-kyc-status-by-user?customer_identifier=${encodeURIComponent(mobile)}`
        );
        const data = res.data;

        if (data.status === "approved") {
          setStep(3);
          // Don't set extractedData for revisited users
          Swal.fire({
            icon: "success",
            title: "KYC Verified ",
            text: "Your KYC is already completed!",
          });
        } else if (data.status === "pending") {
			const requestRes = await axios.get(
			`${BASE_API_URL}/api/get-kyc-request-status?customer_identifier=${encodeURIComponent(mobile)}`
		  );

		    if (requestRes.data.exists) {

				setKycResponse({
				  id: requestRes.data.kyc_id
				});
				setStep(2);
				setMessage({
				  type: "info",
				  text: `Current Status: ${requestRes.data.status}`
				});
			  } else {

				setStep(2);

				setMessage({
				  type: "info",
				  text: "No KYC request found. Start first."
				});
			  }
		    }
      } catch (err) {
        console.error("Initial KYC check failed:", err);
      } finally {
        setIsInitialLoading(false);
      }
    };

    loadLoggedInUserAndCheckKyc();
  }, []);
  
  // --- Handlers ---
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const completeStep = (num) => {
  //   if (num === 1) setStep(2);
  //   else if (num === 2) setStep(3);
  //   else if (num === 3) {
  //     setVerificationComplete(true);
  //     Swal.fire({
  //       icon: "success",
  //       title: "KYC Verified ",
  //       text: "Congratulations! Your KYC verification is completed.",
  //     });
  //   }
  // };
  // Update completeStep function for fresh verification
  const completeStep = (num) => {
    if (num === 1) setStep(2);
    else if (num === 2) setStep(3);
    else if (num === 3) {
      setFreshlyVerified(true); // mark as freshly completed
      Swal.fire({
        icon: "success",
        title: "KYC Verified ",
        text: "Congratulations! Your KYC verification is completed.",
      });
    }
  };
  const goToStep = (num) => setStep(num);

  // --- API Calls ---
  const startDigiLockerVerification = async () => {
    setMessage(null);
    if (!formData.customer_identifier || !formData.customer_name) {
      setMessage({ type: "error", text: "Fill Username & Phone Number first." });
      return;
    }

    setIsLoading(true);
    try {
      const formPayload = new FormData();
      formPayload.append(
        "customer_identifier",
        formData.customer_identifier
      );

      formPayload.append(
        "customer_name",
        formData.customer_name
      );

      const res = await axios.post(
        `${BASE_API_URL}/api/initiate-kyc`,
        formPayload,
        {
          timeout: 15000
        }
      );
      console.log("Digio Response:", res.data);

      setKycResponse(res.data);

      if (res.data.access_token) {
        window.open(
          `https://app.digio.in/#/gateway/login/${res.data.access_token}`,
          "_blank"
        );
      } else {
        setMessage({
          type: "error",
          text: "Digio access token not received."
        });
      }

      setMessage({
        type: "success",
        text: "KYC Initiated. Complete verification on Digio."
      });

      setStep(2);
    } catch (err) {
      console.error(err);
      const detail = err.response?.data?.detail || err.message;
      setMessage({ type: "error", text: `Failed to initiate KYC: ${detail}` });
    } finally {
      setIsLoading(false);
    }
  };

  const checkVerificationStatus = async () => {
    setMessage(null);
    setExtractedData(null);
	const kycId = kycResponse?.id || kycResponse?.kyc_id;

    if (!kycId) {
	  setMessage({
		type: "error",
		text: "No KYC request found. Start first."
	  });
	  return;
	}

    setIsLoading(true);
    try {
      const res = await axios.post(`${BASE_API_URL}/api/check-kyc-status`, {
        kyc_id: kycId,
        customer_identifier: formData.customer_identifier,
      });

      const data = res.data;

      if (data.status?.toLowerCase() === "approved") {
        setExtractedData(data.extracted_data || null);
        completeStep(3); // Shows SweetAlert popup
      } else {
        setMessage({ type: "info", text: `Current Status: ${data.status || "pending"}` });
      }
    } catch (err) {
      console.error(err);
      const detail = err.response?.data?.detail || err.message;
      setMessage({ type: "error", text: `Failed to fetch KYC status: ${detail}` });
    } finally {
      setIsLoading(false);
    }
  };

  // const redirectToDashboard = () => {
  //   alert("Redirecting to Dashboard...");
  // };
  const redirectToDashboard = () => {
    if (window.confirm("Redirecting to Dashboard...")) {
      window.location.href = "/dashboard";
    }
  };
  const renderMessage = () => {
    if (!message) return null;
    const cls = message.type === "error" ? "kyc-msg-error" : message.type === "success" ? "kyc-msg-success" : "kyc-msg-info";
    return <div className={`kyc-message ${cls}`}>{message.text}</div>;
  };

  if (isInitialLoading)
    return (
      <div className="kyc-main-content" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <h2><FaSyncAlt className="fa-spin" /> Checking KYC Status...</h2>
      </div>
    );

  return (
    <>
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className="kyc-main-content">
        <div className="kyc-container">
          <div className="kyc-header">
            <h1 className="kyc-title"><i className="fas fa-user-check"></i> KYC Verification</h1>
            <p className="kyc-subtitle">Complete your verification to unlock all contribution opportunities</p>
          </div>

          {/* Progress Tracker */}
          <div className="progress-tracker">
            <div className="progress-line"></div>
            <div className="progress-fill" style={{ width: `${(step - 1) * 50}%` }}></div>
            <div className="progress-steps">
              {["Personal Info", "Identity", "Final Details"].map((label, index) => (
                <div key={index} className={`progress-step ${step >= index + 1 ? "active" : ""}`}>
                  <div className="step-number"><span>{index + 1}</span><FaCheck /></div>
                  <div className="step-label">{label}</div>
                </div>
              ))}
            </div>
          </div>

          {renderMessage()}

          {/* STEP CONTENTS */}
          {/* Step 1 */}
          {step === 1 && (
            <div className="step-content active">
              <h3 className="step-title"><FaUser /> Personal Information</h3>
              <form className="kyc-form" onSubmit={(e) => e.preventDefault()}>
                <div className="kyc-form-group">
                  <label>Username</label>
                  <input type="text" className="input" name="customer_name" value={formData.customer_name} onChange={handleFormChange} required />
                </div>
                <div className="kyc-form-group">
                  <label>Phone number</label>
                  <input type="tel" className="input" name="customer_identifier" value={formData.customer_identifier} onChange={handleFormChange} required pattern="[0-9]{10}" placeholder="10 digit mobile number" />
                </div>
                <div className="kyc-form-actions">
                  <button type="button" className="btn btn-primary" onClick={() => completeStep(1)} disabled={!formData.customer_identifier || !formData.customer_name}>
                    <FaArrowRight /> Continue
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Step 2 */}
          {step === 2 && (
            <div className="step-content active">
              <h3 className="step-title"><FaIdCard /> DigiLocker Identity Verification</h3>
              <div className="digilocker-card">
                <div className="digilocker-header">
                  <img src={digilockerLogo} alt="DigiLocker" style={{ width: "60px", height: "60px" }} />
                  <div><h4>DigiLocker Verification</h4><p>Verify Aadhaar & PAN securely</p></div>
                </div>
                <div className="verification-actions">
                  <button className="btn btn-digilocker" onClick={startDigiLockerVerification} disabled={isLoading}>
                    {isLoading ? "Initiating..." : <><FaShieldAlt /> Start DigiLocker Verification</>}
                  </button>
                  <button className="btn btn-success" onClick={checkVerificationStatus} disabled={isLoading || !kycResponse}>
                    {isLoading ? "Checking..." : <><FaSyncAlt /> Check Verification Status</>}
                  </button>
                </div>
              </div>
              <div className="kyc-form-actions">
                <button className="btn btn-outline" onClick={() => goToStep(1)}><FaArrowLeft /> Back</button>
              </div>
            </div>
          )}

          {/* Step 3 */}
          {/* {step === 3 && (
            <div className="step-content active">
              <h3 className="step-title"><FaClipboardCheck /> Final Details</h3>
              {extractedData && (
                <div className="extracted-data-panel">
                  <h4>Extracted KYC Data</h4>
                  <div><strong>Aadhaar:</strong> {extractedData.AadhaarNo || "N/A"}</div>
                  <div><strong>PAN:</strong> {extractedData.PanNo || "N/A"}</div>
                  <div><strong>Bank Status:</strong> {extractedData.BankStatus || "N/A"}</div>
                </div>
              )}
              <div className="kyc-form-actions">
                <button className="btn btn-primary" onClick={redirectToDashboard}><FaTachometerAlt /> Go to Dashboard</button>
              </div>
            </div>
          )} */}
          {/* // In Step 3 rendering, conditionally render extractedData only if freshlyVerified */}
          {step === 3 && (
            <div className="step-content active">
              <h3 className="step-title"><FaClipboardCheck /> Final Details</h3>
              {freshlyVerified && extractedData && (
                <div className="extracted-data-panel">
                  <h4>Extracted KYC Data</h4>
                  <div><strong>Aadhaar:</strong> {extractedData.AadhaarNo || "N/A"}</div>
                  <div><strong>PAN:</strong> {extractedData.PanNo || "N/A"}</div>
                  <div><strong>Bank Status:</strong> {extractedData.BankStatus || "N/A"}</div>
                </div>
              )}
              <div className="kyc-form-actions">
                <button className="btn btn-primary" onClick={redirectToDashboard}><FaTachometerAlt /> Go to Dashboard</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default KYCPage;
